<template>
    <div
        class="supsis-button"
        :class="{
            [classNames]: true,
            disabled,
            primary,
            danger,
            warning,
            ghost,
            small,
            xsmall,
            xxsmall,
            large,
            xlarge,
            block,
            icon,
            square,
            'has-floating-label': floatingLabel,
            focused: focused,
            filled: filled,
        }"
        @click="click"
        :id="id"
        v-bind="$attrs"
    >
        <label v-if="floatingLabel" class="floating-label">{{ floatingLabel }}</label>
        <i v-if="icon" class="material-icons">{{ icon }}</i>
        <slot />
    </div>
</template>

<script>
export default {
    name: "SupsisButton",
    props: {
        classNames: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        primary: {
            type: Boolean,
            default: false,
        },
        danger: {
            type: Boolean,
            default: false,
        },
        warning: {
            type: Boolean,
            default: false,
        },
        ghost: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
        xsmall: {
            type: Boolean,
            default: false,
        },
        xxsmall: {
            type: Boolean,
            default: false,
        },
        large: {
            type: Boolean,
            default: false,
        },
        xlarge: {
            type: Boolean,
            default: false,
        },
        block: {
            type: Boolean,
            default: false,
        },
        square: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
        },
        icon: {
            type: String,
            default: "",
        },
        floatingLabel: {
            type: String,
            default: "",
        },
        focused: {
            type: Boolean,
            default: false,
        },
        filled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        click(event) {
            if (this.disabled) {
                return;
            }
            this.$emit("click", event);
        },
    },
};
</script>

<style scoped lang="scss">
.supsis-button {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 64px;
    max-width: fit-content;
    height: 35px;
    border-radius: 5px;
    cursor: pointer;
    gap: 4px;
    padding: 5px 10px;
    position: relative;

    border: 1px solid var(--color-bg-neutral-default);
    background-color: var(--color-bg-neutral-default);
    color: var(--color-text-default);

    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    pointer-events: all;

    &.square {
        aspect-ratio: 1/1;
        min-width: auto;
        padding: 0;
    }

    &.icon {
        padding: 0;
        border: none;
        background-color: transparent;

        .material-icons {
            font-size: 24px;
        }
    }

    &.small {
        min-width: 32px;
    }

    &.xsmall {
        min-width: 24px;
    }

    &.xxsmall {
        min-width: 16px;
    }

    &.large {
        padding: 20px 30px;
    }

    &.xlarge {
        padding: 30px 50px;
    }

    &.block {
        width: 100%;
        max-width: unset;
        justify-content: center;
        align-items: center;
    }

    &:hover {
        opacity: 0.8;
    }

    &.primary {
        border: 1px solid #22272d;
        background-color: #22272d;
        color: var(--color-text-onprimary-default);
    }

    &.danger {
        border: 1px solid var(--color-border-critical-default);
        background-color: var(--color-bg-critical-default);
        color: var(--color-text-onprimary-default);
    }

    &.warning {
        border: 1px solid var(--color-border-warning-default);
        background-color: var(--color-bg-warning-default);
        color: var(--color-text-onprimary-default);
    }

    &.supsis-base {
        border: 1px solid rgb(236, 75, 29);
        background-color: rgb(236, 75, 29);
        color: var(--color-text-onprimary-default);

        &:hover {
            opacity: 0.8;
        }
    }

    &.primary:hover {
        opacity: 0.8;
    }

    &.ghost {
        border: 1px solid #22272d;
        background-color: transparent;
        color: var(--default-text-color);

        &.danger {
            border: 1px solid var(--color-border-critical-default);
            color: var(--color-bg-critical-default);
        }
        &.warning {
            border: 1px solid var(--color-border-warning-default);
            color: var(--color-bg-warning-default);
        }
    }

    &:active {
        opacity: 0.8;
    }

    &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
}

/* Floating label for button (MUI-like) */
.supsis-button.has-floating-label {
    padding-top: 12px; /* Üst kısımda label için yer aç */
    
    .floating-label {
        position: absolute;
        top: -8px;
        left: 12px;
        font-size: 12px;
        color: var(--color-bg-neutral-default); /* Butonun border rengiyle aynı */
        padding: 0 4px;
        pointer-events: none;
        transition: color 0.2s ease;
        z-index: 1;
    }
    
    &.focused .floating-label,
    &.filled .floating-label {
        color: #22272d; /* Focus durumunda buton border rengi */
    }
    
    &.ghost .floating-label {
        color: #22272d; /* Ghost buton için border rengi */
    }
    
    &.ghost.focused .floating-label,
    &.ghost.filled .floating-label {
        color: #22272d;
    }
}
</style>
